import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';

import AsyncForm from './components/async-form';
import Blog from './components/blog';
import BookStore from './components/bookstore';
import Carousel from './components/carousel';
import ClosestEvents from './components/closest-events';
import CourseReviews from './components/course-reviews';
import Dictionary from './components/dictionary';
import EventsRow from './components/events-row';
import EventsTable from './components/events-table';
import FlyingButton from './components/flying-button';
import LastSeen from './components/last-seen';
import Order from './components/order';
import Modal from './components/modal';
import Search from './components/search';
import Tabs from './components/tabs';
import VimeoPlayer from './components/vimeo-player';
import VimeoThumbnail from './components/vimeo-thumbnail';
import ZoomOnScroll from './components/zoom-on-scroll';
import TextareaAutoheight from './components/textarea-autoheight';
import DataLayerEvents from './components/data-layer-events.js';

const BASE_URL_METHODICS = '/api/taxonomies/methodics/terms';
const BASE_URL_AUDITS = '/api/collections/audits/entries';

window.Alpine = Alpine;

Alpine.plugin(persist);

Alpine.data('asyncForm', AsyncForm);
Alpine.data('blog', Blog);
Alpine.data('bookstore', BookStore);
Alpine.data('carousel', Carousel);
Alpine.data('closestEvents', ClosestEvents);
Alpine.data('courseReviews', CourseReviews);
Alpine.data('dataLayerEvents', DataLayerEvents);
Alpine.data('dictionary', Dictionary);
Alpine.data('eventsTable', EventsTable);
Alpine.data('flyingButton', FlyingButton);
Alpine.data('lastSeen', LastSeen);
Alpine.data('modal', Modal);
Alpine.data('order', Order);
Alpine.data('row', EventsRow);
Alpine.data('search', Search);
Alpine.data('tabs', Tabs);
Alpine.data('textareaAutoheight', TextareaAutoheight);
Alpine.data('vimeoPlayer', VimeoPlayer);
Alpine.data('vimeoThumbnail', VimeoThumbnail);
Alpine.data('zoomOnScroll', ZoomOnScroll);

Alpine.store('events', {
  events: [],
  dataFetched: false,

  set(events) {
    this.events = events;
    this.dataFetched = true;
  },

  get() {
    return this.events;
  },

  hasEvents() {
    return this.events.length > 0;
  },
});

Alpine.store('methodics', {
  filter: {
    query: '',
    methodics: [],
    role: [],
  },
  dataFetched: false,
  filterActivated: false,
  loading: false,
  data: [],

  filterData(filter) {
    this.filter = filter;
    this.filterActivated = true;
    this.getData(filter);
  },

  get methodicFilterQuery() {
    return this.filter.methodics.length
      ? `&filter[id:in]=${this.filter.methodics.join('|')}`
      : '';
  },

  get roleFilterQuery() {
    return this.filter.role.length
      ? `&filter[role:in]=${this.filter.role.join('|')}`
      : '';
  },

  get stringQuery() {
    return this.filter.query.length > 2
      ? `&filter[title:contains]=${this.filter.query}`
      : '';
  },

  getData() {
    this.loading = true;

    fetch(
      `${BASE_URL_METHODICS}?filter[active:is]=true&sort=title&filter[site]=cs${
        this.methodicFilterQuery + this.roleFilterQuery + this.stringQuery
      }&fields=url,title,logo,border_color,box_text,entries_count,box_footer_text`
    )
      .then((response) => response.json())
      .then((response) => {
        this.data = response.data;
        this.loading = false;
      });
  },
});

Alpine.store('audits', {
  filter: {
    query: '',
    audits: [],
    fields: [],
  },
  dataFetched: false,
  filterActivated: false,
  loading: false,
  data: [],

  filterData(filter, category = null) {
    this.filter = filter;
    this.filterActivated = true;
    this.getData(filter, category);
  },

  get auditsFilterQuery() {
    return this.filter.audits.length
      ? `&filter[id:in]=${this.filter.audits.join('|')}`
      : '';
  },

  get fieldsFilterQuery() {
    return this.filter.fields.length
      ? `&filter[taxonomy:fields:in]=${this.filter.fields.join('|')}`
      : '';
  },

  get stringQuery() {
    return this.filter.query.length > 2
      ? `&filter[title:contains]=${this.filter.query}`
      : '';
  },

  categoryQuery(category) {
    return category !== null ? `&filter[category:is]=${category}` : '';
  },

  getData(filter, category) {
    this.loading = true;
    fetch(
      `${BASE_URL_AUDITS}?filter[published:is]=true&sort=title&filter[site]=cs${
        this.auditsFilterQuery +
        this.fieldsFilterQuery +
        this.stringQuery +
        this.categoryQuery(category)
      }&fields=url,title,border_color,box_text,box_footer_text`
    )
      .then((response) => response.json())
      .then((response) => {
        this.data = response.data;
        this.loading = false;
      });
  },
});

Alpine.start();
